const ParticleText = ({ children }) => {
    return (
        <span
            className="particle-text"
            data-particle-target="brand"
        >
            <span className="particle-text__label">
                {children}
            </span>
        </span>
    );
};

export default ParticleText;